import { Button, ButtonGroup, makeStyles, Popover, withStyles } from "@material-ui/core";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { THEME_MODE } from "src/config/constants";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import DatepickerPaper from "src/components/DatepickerPaper";

export const DATE_OPTION = [
  { label: "1D", number: 24, interval: 1 },
  { label: "1W", number: 84, interval: 2 },
  { label: "1M", number: 360, interval: 2 },
  { label: "3M", number: 540, interval: 4 },
];

const CssButtonGroup = withStyles((theme) => ({
  root: {
    background: theme.palette.type === THEME_MODE.DARK ? "#07111C" : "#F2F5FA",
    border: theme.palette.type === THEME_MODE.DARK ? "1px solid #263343" : "1px solid #DEDEDE",
    borderRadius: "6px",
    overflow: "hidden",
  },
}))(ButtonGroup);

const useStyle = makeStyles((theme) => ({
  but: {
    color: theme.palette.type === THEME_MODE.DARK ? "#FFFFFF" : "#566474",
    border: "none",
  },
  activeBut: {
    color: "#FFFFFF",
    background: "#408CEC",
    "&:hover": {
      background: "#408CEC",
    },
  },
}));

export default function DateGroupButton({ config = [], defaultActive = 0, picker, ...props }) {
  const cls = useStyle();
  const [active, setActive] = useState(defaultActive);
  const _len = config.length;

  useEffect(() => {
    if (defaultActive != active) setActive(defaultActive);
  }, [defaultActive]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "scoring-datepicker-popover" : undefined;

  function onContinueClick(start, end) {
    const startTimestamp = Math.floor(start.getTime() / 1000);
    const endTimestamp = Math.floor(end.getTime() / 1000);
    if (picker?.continueClick) picker.continueClick(startTimestamp, endTimestamp, _len);
    setActive(_len);
    setAnchorEl(null);
  }

  return (
    <>
      <CssButtonGroup {...props}>
        {config.map((element, index) => {
          return (
            <Button
              key={index}
              className={clsx(cls.but, { [cls.activeBut]: index === active })}
              onClick={() => {
                if (element.onClick) element.onClick(element.data, index);
                setActive(index);
              }}
            >
              {element.data.label}
            </Button>
          );
        })}
        <Button
          onClick={(event) => setAnchorEl(event.currentTarget)}
          className={clsx(cls.but, { [cls.activeBut]: _len === active })}
        >
          <CalendarTodayOutlinedIcon fontSize="small" />
        </Button>
      </CssButtonGroup>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ style: { padding: 0 } }}
      >
        <DatepickerPaper
          {...picker}
          event={{ onContinueClick: onContinueClick, onCancelClick: () => setAnchorEl(null) }}
        />
      </Popover>
    </>
  );
}
